import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

type ButtonVariant = 'flat' | 'raised' | 'stroked' | 'icon' | 'fab' | 'extended-fab';
type ButtonSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'] 
})
export class ButtonComponent implements OnInit {
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() variant: ButtonVariant = 'raised';
  @Input() size: ButtonSize = 'medium';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() icon?: string;
  @Input() iconPosition: 'start' | 'end' = 'start';
  @Input() tooltip?: string;
  @Input() fullWidth = false;
  @Input() customClass?: string;

  @Output() click = new EventEmitter<void>();
  sizeClass = '';
  variantClass = '';
  

  onClick() {
    if (!this.disabled && !this.loading) {
      this.click.emit();
    }
  }
  ngOnInit() {
    this.sizeClass = this.size === 'small' ? 'btn-sm' : this.size === 'large' ? 'btn-lg' : '';
    this.variantClass = this.variant === 'flat' ? 'btn-flat' : this.variant === 'raised' ? 'btn-raised' : this.variant === 'stroked' ? 'btn-stroked' : this.variant === 'icon' ? 'btn-icon' : this.variant === 'fab' ? 'btn-fab' : this.variant === 'extended-fab' ? 'btn-extended-fab' : '';
  }

  get buttonClasses(): string[] {
    const classes = [this.variantClass, this.sizeClass];
    if (this.fullWidth) classes.push('full-width');
    if (this.customClass) classes.push(this.customClass);
    return classes.filter(c => c); // Remove empty strings
  }

  get isDisabled() {
    return this.disabled || this.loading;
  }
}

//Usage: <app-button (click)="onClick()" [color]="'primary'" [variant]="'raised'" [size]="'medium'" [disabled]="false" [loading]="false" [icon]="'add'" [iconPosition]="'start'" [tooltip]="'Add'" [fullWidth]="false" [customClass]="'custom-class'"></app-button>
